import React from 'react'
import { Field, Form, Formik } from 'formik'
import { useUpdateMutation } from '../../queries/work-periods'
import { RequestButton, RequestMessage } from '../request-components/request-components'
import SelectField from '../form/fields/select'
import { buildListAsInputOptions } from '../../utils/forms'
import { useServicesQuery } from '../../queries/services'
import { WorkPeriod, WorkPeriodUpdatePayload } from '../../api/work-periods'
import { getDocIdAsString } from '../../utils/documents'

/**
 * Props for the WorkPeriodServiceForm component
 */
export interface WorkPeriodServiceFormProps {
  workPeriod: WorkPeriod
}

/**
 * Form component for editing work period service
 * @param workPeriodId - The ID of the work period to update
 * @param missionId - The ID of the mission
 * @param initialServiceId - The initial service ID if editing
 */
const WorkPeriodServiceForm: React.FC<WorkPeriodServiceFormProps> = ({ workPeriod }) => {
  const updateMutation = useUpdateMutation()
  const servicesQuery = useServicesQuery()

  return (
    <Formik
      initialValues={{ service: getDocIdAsString(workPeriod.service) || '' }}
      enableReinitialize
      validate={values => {
        const errors: any = {}
        if (!values.service) errors.service = 'Champ requis'
        return errors
      }}
      onSubmit={values => {
        const payload: WorkPeriodUpdatePayload = {
          missionId: getDocIdAsString(workPeriod.mission),
          workPeriodId: getDocIdAsString(workPeriod),
          service: values.service,
        }
        updateMutation.mutate(payload)
      }}
    >
      {() => (
        <Form autoComplete="off">
          <Field
            label="Affectation"
            name="service"
            component={SelectField}
            options={buildListAsInputOptions(servicesQuery.data || [])}
          />
          <RequestButton color="primary" type="submit" mutation={updateMutation}>
            Mettre à jour l'Affectation
          </RequestButton>
          <RequestMessage mutation={updateMutation} />
        </Form>
      )}
    </Formik>
  )
}

export default WorkPeriodServiceForm
